import { EnvironmentOutlined } from "@ant-design/icons";
import { PageHeader, Space, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, ModalItem, RangePickerItem, TableItemDinamico } from "../../../Components/Items";
import SelectEmpleadosItem from "../../../Components/SelectEmpleadosItem";
import MapaUbicacionChecada from "../../../Components/MapaPerimetro/MapaUbicacionChecada";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

// Códigos que manda el backend (IntentoChecadaRechazado.motivo) → texto para RH
const MOTIVOS = {
    sin_permiso: { texto: "Sin permiso de checada remota", color: "default" },
    dispositivo_faltante: { texto: "Sin identificador de celular", color: "default" },
    dispositivo_no_autorizado: { texto: "Celular no autorizado", color: "red" },
    ubicacion_simulada: { texto: "Ubicación simulada", color: "red" },
    ubicacion_invalida: { texto: "Ubicación inválida", color: "orange" },
    sin_perimetros: { texto: "Sin perímetros asignados", color: "default" },
    fuera_perimetro: { texto: "Fuera del perímetro", color: "orange" },
    precision_insuficiente: { texto: "GPS impreciso", color: "gold" },
    fuera_horario: { texto: "Fuera de horario", color: "blue" },
    checada_duplicada: { texto: "Checada duplicada", color: "default" },
    hora_invalida: { texto: "Hora del celular inválida", color: "red" },
    hora_futura: { texto: "Hora en el futuro", color: "red" },
    checada_expirada: { texto: "Checada offline expirada", color: "orange" },
    empresa_sin_checada_remota: { texto: "Empresa sin checada remota", color: "default" },
    rostro_sin_foto: { texto: "Sin fotografía registrada", color: "gold" },
    rostro_no_verificado: { texto: "Rostro no verificado", color: "orange" },
    rostro_no_coincide: { texto: "El rostro no coincide", color: "red" },
};

class IntentosChecadaRechazados extends Component {
    tableRef = null;
    state = {
        todosIntentos: [],
        loading: false,
        rangoFechas: null,
        empleadoId: undefined,
        intentoMapa: null,
    };
    consultarIntentos(params) {
        this.setState({ loading: true });
        axios
            .post(
                "perimetrosChecada/selectIntentosChecadaRechazados",
                { empresaId: this.props.empresaId, ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    this.setState({ todosIntentos: [] });
                } else {
                    this.setState({
                        todosIntentos: res.data.data,
                        totalRecords: res.data.totalRecords || 0,
                    });
                }
            });
    }

    aplicarFiltros() {
        const { rangoFechas, empleadoId } = this.state;
        if (this.tableRef) {
            this.tableRef.updateExternalFilters({
                fechaInicio: rangoFechas?.[0] ? moment(rangoFechas[0]).startOf("day").toISOString() : undefined,
                fechaFin: rangoFechas?.[1] ? moment(rangoFechas[1]).endOf("day").toISOString() : undefined,
                empleadoId: empleadoId || undefined,
            });
        }
    }

    render() {
        const columns = [
            {
                title: "Fecha",
                dataIndex: "fechaIntento",
                key: "fechaIntento",
                width: "12%",
                render: (value) => (value ? moment(value).format("DD/MM/YYYY HH:mm:ss") : "—"),
            },
            {
                title: "Empleado",
                dataIndex: "empleadoNombre",
                key: "empleadoNombre",
                width: "20%",
            },
            {
                title: "Tipo",
                dataIndex: "tipo",
                key: "tipo",
                width: "7%",
                render: (value) => {
                    if (value === "entrada") return <span style={{ color: "#1677ff", fontWeight: "bold" }}>Entrada</span>;
                    if (value === "salida") return <span style={{ color: "#fa541c", fontWeight: "bold" }}>Salida</span>;
                    return "—";
                },
            },
            {
                title: "Motivo",
                dataIndex: "motivo",
                key: "motivo",
                width: "18%",
                render: (value, record) => {
                    const motivo = MOTIVOS[value] || { texto: value, color: "default" };
                    return (
                        <Tooltip title={record.mensaje}>
                            <Tag color={motivo.color}>{motivo.texto}</Tag>
                        </Tooltip>
                    );
                },
            },
            {
                title: "Mensaje al empleado",
                dataIndex: "mensaje",
                key: "mensaje",
                width: "25%",
            },
            {
                title: "Rostro",
                dataIndex: "verificacionRostro",
                key: "verificacionRostro",
                align: "center",
                width: "7%",
                render: (value) =>
                    Number.isFinite(value?.puntaje)
                        ? `${(value.puntaje * 100).toFixed(0)}%`
                        : "—",
            },
            {
                title: "Precisión GPS",
                dataIndex: "ubicacion",
                key: "precision",
                align: "center",
                width: "8%",
                render: (value) => (Number.isFinite(value?.precision) ? `±${Math.round(value.precision)} m` : "—"),
            },
            {
                title: "Offline",
                dataIndex: "offline",
                key: "offline",
                align: "center",
                width: "6%",
                render: (value) => (value ? <Tag color="purple">Offline</Tag> : null),
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                width: "6%",
                render: (value, record) => {
                    if (!Number.isFinite(record.ubicacion?.lat) || !Number.isFinite(record.ubicacion?.lng)) return null;
                    return (
                        <div className="acciones-container">
                            <Tooltip
                                title="Ver en mapa"
                                placement="top"
                                overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                            >
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    cyan
                                    icon={<EnvironmentOutlined />}
                                    onClick={() => this.setState({ intentoMapa: record })}
                                >
                                </ButtonItem>
                            </Tooltip>
                        </div>
                    );
                }
            },
        ];

        const { intentoMapa } = this.state;

        return (
            <>
                <PageHeader
                    title="Intentos de Checada Rechazados"
                    subTitle="Checadas desde la app que el servidor no aceptó"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <Space>
                            <RangePickerItem
                                value={this.state.rangoFechas}
                                onChange={(rangoFechas) => this.setState({ rangoFechas }, () => this.aplicarFiltros())}
                            />
                            <SelectEmpleadosItem
                                empresaId={this.props.empresaId}
                                headersToken={this.props.headersToken}
                                sinBorde
                                allowClear
                                width={260}
                                placeholder="Empleado"
                                value={this.state.empleadoId}
                                onChange={(empleadoId) => this.setState({ empleadoId }, () => this.aplicarFiltros())}
                            />
                        </Space>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    loading={this.state.loading}
                    onFetchData={this.consultarIntentos.bind(this)}
                    size="small"
                    dataSource={this.state.todosIntentos}
                    columns={columns}
                    scroll={{ x: "max-content" }}
                />
                <ModalItem
                    title="Ubicación del intento de checada"
                    visible={!!intentoMapa}
                    onCancel={() => this.setState({ intentoMapa: null })}
                    paddingTop
                >
                    {intentoMapa && (
                        <>
                            <div style={{ marginBottom: 8, fontSize: 13 }}>
                                <b>{intentoMapa.empleadoNombre}</b>
                                {" · "}
                                {moment(intentoMapa.fechaIntento).format("DD/MM/YYYY HH:mm:ss")}
                                {" · "}
                                {(MOTIVOS[intentoMapa.motivo] || { texto: intentoMapa.motivo }).texto}
                            </div>
                            <MapaUbicacionChecada ubicacion={intentoMapa.ubicacion} />
                        </>
                    )}
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(IntentosChecadaRechazados);
